// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SaveUser";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import { AccountModel, AccountSettingsModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        onError?: (error: string) => void;
    } & HasOnSuccess,
    UpdateAccountApiParameter,
    ServiceResult<AccountModel>,
    { accountSettings: AccountSettingsModel }
>;

export const XPopulateApiParameter: HandlerType = props => {
    const editingUser = getCurrentEditingUser(props.getState());
    if (!editingUser) {
        return false;
    }

    props.accountSettings = getSettingsCollection(props.getState()).accountSettings;

    const phone = (props.getState() as any).xAccountSettings.properties.phone;
    let language = (props.getState() as any).xAccountSettings.properties.language;
    const isSentinelUser = (props.getState() as any).xUserSetup.properties.isSentinelUser;
    const isThinkificUser = (props.getState() as any).xUserSetup.properties.isThinkificUser;

    if (!language) {
        language = props.getState().context.session.language?.id;
    }

    props.apiParameter = {
        account: {
            ...editingUser,
            properties: {
                ...editingUser.properties,
                phone,
                isSentinelUser,
                isThinkificUser,
                language,
            },
            userName: props.accountSettings.useEmailAsUserName ? editingUser.email : editingUser.userName,
        },
    };
};

replaceInChain(chain, PopulateApiParameter, XPopulateApiParameter as any);
